import { IApplicationState } from '../../../../../../../types/types';
import { connect } from 'react-redux';
import { ICardColorTagsEvents, ICardColorTagsFields } from '../components/types';
import { ICardColorTagsHOCProps } from './types';
import { CardColorTags } from '../components/CardColorTags';
import { onToggle } from './events/onToggle';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { onOpenSettings } from '../../NewCardColorTags/hocs/NewCardColorTagsHOC/events/onOpenSettings';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { onCloseModal } from '../../NewCardColorTags/hocs/NewCardColorTagsHOC/events/onCloseModal';
import { onOpen } from './events/onOpen';
import { getBoardPermissionsIsReadonly } from '../../../selectors/getBoardPermissionsIsReadonly';
import {
    getBoardUserMetaRecentColorTags
} from '../../../../../../../store/model/board/selectors/getBoardUserMetaRecentColorTags';
import { getBoardColorsByStatus } from '../../../../../../../store/model/board/selectors/getBoardColorsByStatus';
import { getBoardCardColorTagsCreateSelector } from '../../../../../../../store/model/selectors/getBoardCardColorTags';
import { getColorTagsSearchScroll } from '../../../store/selectors/getColorTagsSearchScroll';
import { getHint } from '../../../../../hints/store/hints/selectors/getHint';
import { EHintKey, EHintStatus } from '../../../../../hints';
import { onHideHint } from './events/onHideHint';

const mapStateToProps = () => {
    const getBoardCardColorTags = getBoardCardColorTagsCreateSelector();
    const _mapStateToProps = (
        state: IApplicationState,
        { cardId, colorTags: _colorTags, isOpened }: ICardColorTagsHOCProps
    ): ICardColorTagsFields => {
        const colorTags = _colorTags || [];
        const { listId } = getCard(state, cardId);
        const { allowColorTagCount } = getAuthUser(state);
        const boardId = getBoardIdByCardId(state, cardId);
        const showColorTagsCount = [...new Set([
            ...colorTags.map(colorTag => colorTag.id),
            ...getBoardUserMetaRecentColorTags(state, boardId)
        ])].length || getBoardCardColorTags(state, boardId).length || getBoardColorsByStatus(state, boardId).length;
        return {
            aloudCount: allowColorTagCount,
            boardId: getBoardIdByCardId(state, cardId),
            cardId,
            colorTags,
            isHintShown: getHint(state, EHintKey.KANBAN_COLOR_TAGS_SCROLL_UP).status === EHintStatus.SHOWN,
            isNeedToScroll: getColorTagsSearchScroll(state),
            isOpened,
            isReadonly: getBoardPermissionsIsReadonly(state, getBoardIdByCardId(state, cardId)),
            listId,
            showColorTagsCount,
        };
    };
    return _mapStateToProps;
}

const mapDispatchToProps = (
    dispatch: any,
    { cardId, setOpened }: ICardColorTagsHOCProps
): ICardColorTagsEvents => {
    return {
        onClose: () => dispatch(onCloseModal()),
        onHideHint: () => dispatch(onHideHint()),
        onToggle: (colorTagId, source) => dispatch(onToggle(cardId, colorTagId, source)),
        onOpenSettings: () => dispatch(onOpenSettings()),
        onOpen: () => dispatch(onOpen()),
        setOpened,
    };
};
export const CardColorTagsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardColorTags);

CardColorTagsHOC.displayName = 'CardColorTagsHOC';
